function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ECA477",
  d: "M20.947 8.305c-.01-.757-.15-1.508-.419-2.216-.469-1.209-1.424-2.165-2.633-2.633-.699-.263-1.438-.404-2.186-.42-.962-.043-1.267-.055-3.709-.055s-2.755 0-3.71.055c-.747.016-1.486.157-2.185.42-1.209.468-2.165 1.424-2.633 2.633-.263.699-.405 1.438-.419 2.185-.043.963-.056 1.268-.056 3.71s0 2.754.056 3.71c.015.748.156 1.486.42 2.187.468 1.208 1.423 2.164 2.633 2.632.696.272 1.435.426 2.185.45.963.043 1.268.056 3.71.056s2.755 0 3.71-.056c.747-.015 1.486-.156 2.186-.419 1.21-.469 2.164-1.425 2.633-2.633.263-.7.404-1.438.42-2.187.042-.962.055-1.267.055-3.71-.002-2.442-.002-2.752-.058-3.709zm-8.953 8.297c-2.554 0-4.623-2.069-4.623-4.623 0-2.554 2.07-4.623 4.623-4.623 2.552 0 4.623 2.069 4.623 4.623 0 2.554-2.07 4.623-4.623 4.623zm4.807-8.339c-.597 0-1.078-.482-1.078-1.078 0-.596.481-1.078 1.078-1.078.595 0 1.077.482 1.077 1.078 0 .596-.482 1.078-1.077 1.078z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ECA477",
  d: "M11.994 14.982c1.659 0 3.003-1.344 3.003-3.003 0-1.658-1.344-3.003-3.003-3.003-1.658 0-3.003 1.345-3.003 3.003 0 1.659 1.345 3.003 3.003 3.003z"
});

var SvgBxlInstagramAlt = function SvgBxlInstagramAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBxlInstagramAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bxl-instagram-alt.dbd8591c.svg";
export { ForwardRef as ReactComponent };